import { useEffect } from "react";

const key = (path) => `scroll:${path}`;

export function saveScrollFor(pathAndSearch) {
  try {
    sessionStorage.setItem(key(pathAndSearch), String(window.scrollY || 0));
  } catch {}
}

export function saveCurrentScroll() {
  saveScrollFor(`${window.location.pathname}${window.location.search}`);
}

export function useScrollRestore(ready) {
  useEffect(() => {
    if (!ready) return;
    try {
      const k = key(`${window.location.pathname}${window.location.search}`);
      const y = sessionStorage.getItem(k);
      if (y != null) {
        requestAnimationFrame(() => window.scrollTo(0, Number(y)));
        sessionStorage.removeItem(k);
      }
    } catch {}
  }, [ready]);
}
